<template>
  <main>
    <section class="fk-contents">
      <p class="credit-comp">{{$t('Payment.Complete')}}</p>

      <p class="mod-form-btn"><a href="#" class="btn-base btn-negative btn-quit" @click.prevent="execute">{{$t('General.Return')}}</a></p>
    </section>
  </main>
</template>

<script>
export default {
  methods: {
    execute: function (event) {
      this.$router.push({ name: 'OrderProcessing' })
    }
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CompletedMFCard.vue